<template>
    <section class="section default-hero light-blue-wrapper-background">
        <div class="container hero-container">
            <div class="row d-flex align-items-center justify-content-center">
                <div class="col-lg-9 col-md-10 col-sm-12">
                    <h1 class="mb-0">
                        <i v-if="props.showIcon" class="fas fa-check icon"></i>
                        {{ props.title }}
                    </h1>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
const props = defineProps({
    title: String,
    showIcon: Boolean
})
</script>

<style scoped>
.icon {
    color: #00a096;
    margin-right: 1rem;
}
</style>
